import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewAllProjects: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX - ENABLING FLAT LINT CONFIG
		id: 'command-palette-integration.initial-commands.use-navigation-commands.view-all-projects',
		defaultMessage: 'View all projects',
		description: 'Command that will navigate to the projects page',
	},
	viewAllFilters: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX - ENABLING FLAT LINT CONFIG
		id: 'command-palette-integration.initial-commands.use-navigation-commands.view-all-filters',
		defaultMessage: 'View all filters',
		description: 'Command that will navigate to the filters page',
	},
	viewAllDashboards: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX - ENABLING FLAT LINT CONFIG
		id: 'command-palette-integration.initial-commands.use-navigation-commands.view-all-dashboards',
		defaultMessage: 'View all dashboards',
		description: 'Command that will navigate to the dashboards page',
	},
	goToIssues: {
		id: 'command-palette-integration.initial-commands.use-navigation-commands.go-to-issues',
		defaultMessage: 'Go to issues',
		description: 'Command that will navigate to the new issue view',
	},
	goToPersonalSettings: {
		id: 'command-palette-integration.initial-commands.use-navigation-commands.go-to-personal-settings',
		defaultMessage: 'Go to personal settings',
		description: 'Command that will navigate to the personal settings page',
	},
	viewAllBoards: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX - ENABLING FLAT LINT CONFIG
		id: 'command-palette-integration.initial-commands.use-navigation-commands.view-all-boards',
		defaultMessage: 'View all boards',
		description: 'Command that will navigate to the boards page',
	},
	goToAccountSettings: {
		id: 'command-palette-integration.initial-commands.use-navigation-commands.go-to-account-settings',
		defaultMessage: 'Go to account settings',
		description: 'Command that will navigate to the account settings page',
	},
	viewAllPlans: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX - ENABLING FLAT LINT CONFIG
		id: 'command-palette-integration.initial-commands.use-navigation-commands.view-all-plans',
		defaultMessage: 'View all plans',
		description: 'Command that will navigate to the plans page',
	},
	goToUserManagement: {
		id: 'command-palette-integration.initial-commands.use-navigation-commands.go-to-user-management',
		defaultMessage: 'Go to user management',
		description: 'Command that will navigate to the user management page',
	},
	goToBilling: {
		id: 'command-palette-integration.initial-commands.use-navigation-commands.go-to-billing',
		defaultMessage: 'Go to billing',
		description: 'Command that will navigate to the billing page',
	},
});
